// extracted by mini-css-extract-plugin
export default {"image":"PaymentsTutorial_image__dEfXs","text":"PaymentsTutorial_text__64F7g","modal":"PaymentsTutorial_modal__5nbDm"};